var module = 'main', name = 'main/assets/svg/notification.svg', content = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-18 21 32 32\"><path d=\"M-1.82 21C-10.89 21-18 28.11-18 37s7.29 16 16 16c8.89 0 16-7.11 16-16S6.89 21-1.82 21zm-1.78 8h3.2v5.6c0 3.2-.8 4.8-.8 4.8h-1.6s-.8-1.6-.8-4.8V29zM-2 45.4c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z\"/></svg>";
angular.module(module).run(['$templateCache', function($templateCache) {
  $templateCache.put(name, content);
}]);
module.exports = name;


//////////////////
// WEBPACK FOOTER
// ./main/assets/svg/notification.svg
// module id = 1305
// module chunks = 0